/**
 * List of companies available for user to create an employer profile.
 */
import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../shared/locales/no.json';
import OnboardingUserProfile from './components/OnboardingUserProfile';
import OnboardingCompanyResult from './components/OnboardingCompanyResult';
import OnboardingEmptyCompanyResult from './components/OnboardingEmptyCompanyResult';

class OnboardingCompanyList extends React.Component {
    static propTypes = {
        onContactEmailCanNotFindMyCompany: PropTypes.func.isRequired,
        user: PropTypes.shape({
            user: PropTypes.object,
        }).isRequired,
        userCompanies: PropTypes.shape({
            selectedCompany: PropTypes.object,
            userCompanies: PropTypes.array,
        }).isRequired,
    };

    onEmailClick() {
        this.props.onContactEmailCanNotFindMyCompany();
    }

    renderCompanies() {
        if (
            !this.props.userCompanies.userCompanies ||
            !this.props.userCompanies.userCompanies.length
        ) {
            return <OnboardingEmptyCompanyResult />;
        } else {
            return (
                <OnboardingCompanyResult
                    selectedCompany={this.props.userCompanies.selectedCompany}
                    userCompanies={this.props.userCompanies.userCompanies}
                />
            );
        }
    }

    renderCannotFindSection() {
        return (
            <div className="u-text-center">
                <p>
                    <a
                        href="mailto:kundesenter@finn.no"
                        onClick={this.onEmailClick.bind(this)}
                    >
                        {i18n['Create new']}
                    </a>
                </p>
            </div>
        );
    }

    render() {
        const companies = this.renderCompanies();
        const cannotFindSection = this.renderCannotFindSection();

        return (
            <React.Fragment>
                {this.props.user.user && (
                    <OnboardingUserProfile user={this.props.user.user} />
                )}
                <div className="panel">
                    <fieldset className="form-std__fieldset">
                        <legend>{i18n['Select your company']}</legend>
                        {companies}
                    </fieldset>
                </div>
                <div className="panel">{cannotFindSection}</div>
            </React.Fragment>
        );
    }
}

export default OnboardingCompanyList;
